import { QueryClient, QueryCache, type Query } from '@tanstack/react-query'
import { getMessageApi } from '../lib/app-message'
import { AppError } from '../lib/errors'

const MAX_QUERY_RETRIES = 2
const RETRYABLE_QUERY_STATUSES = new Set([408, 429, 502, 503, 504])
const RETRYABLE_QUERY_CODES = new Set(['NETWORK_ERROR', 'REQUEST_TIMEOUT'])

const shouldRetryQuery = (failureCount: number, error: unknown) => {
  if (failureCount >= MAX_QUERY_RETRIES || !(error instanceof AppError)) return false
  if (error.status !== undefined) return RETRYABLE_QUERY_STATUSES.has(error.status)
  return typeof error.code === 'string' && RETRYABLE_QUERY_CODES.has(error.code)
}

const shouldRefetchAutomatically = (query: Query) => query.state.status !== 'error'

export function createQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        // http interceptor already shows a toast for AppError; only handle unexpected errors here
        if (error instanceof AppError) return
        getMessageApi()?.error('操作失败，请稍后重试')
      },
    }),
    defaultOptions: {
      queries: {
        retry: shouldRetryQuery,
        retryOnMount: false,
        refetchOnMount: shouldRefetchAutomatically,
        refetchOnWindowFocus: false,
        refetchOnReconnect: shouldRefetchAutomatically,
        staleTime: 5 * 60 * 1000,
      },
    },
  })
}

export const queryClient = createQueryClient()
